import { call, put } from 'redux-saga/effects';

import generateQuery from 'utils/generateQuery';

import {
  axiosAuthInstance,
  API_END_POINTS,
} from 'api';

import { MESSAGES } from 'appconstants';

import {
  MEMBERSHIP,
  LOADING,
  NOTIFICATION,
} from '../actionTypes';

const fetchMembership = async (payload) => {
  const query = generateQuery(payload.currentPage);
  const sorting = payload.sortParams ? payload.sortParams : '&sortBy=user.givenName&direction=DESC';
  if (payload.filterParams && !payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_MEMBERSHIPS}?${payload.filterParams}`);
  }
  if (payload.filterParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_MEMBERSHIPS}${query}${sorting}&${payload.filterParams}`);
  }
  if (!payload.filterParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_MEMBERSHIPS}${query}${sorting}`);
  }
  return axiosAuthInstance.get(`${API_END_POINTS.GET_MEMBERSHIPS}${query}${sorting}`);
};
const postMembership = async payload => axiosAuthInstance.post(API_END_POINTS.ADD_MEMBERSHIP, payload);

const patchMembership = async ({ memberId, setTo, user }) => axiosAuthInstance.patch(`${API_END_POINTS.UPDATE_MEMBERSHIPS}/${memberId}`, {
  roleGid: setTo,
  user,
});

const deleteMember = async ({ gid }) => axiosAuthInstance.delete(`${API_END_POINTS.GET_MEMBERSHIPS}/${gid}`);

export function* getMembership(action) {
  try {
    const { data: { entity } } = yield call(fetchMembership, action.payload);
    yield put({ type: MEMBERSHIP.SUCCESS, payload: entity });
  } catch (e) {
    yield put({ type: MEMBERSHIP.FAILED, payload: e.response.data });
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  }
}

export function* addMembership(action) {
  try {
    yield put({ type: LOADING.SUBMITTING });
    yield put({ type: LOADING.VALIDATING });
    yield call(postMembership, action.payload);
    const { data: { entity } } = yield call(fetchMembership, action.payload);
    yield put({ type: MEMBERSHIP.SUCCESS, payload: entity });
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: MESSAGES.MEMBERSHIP.ADD_SUCCESS,
    });
    yield put({ type: LOADING.VALIDATED });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
  }
}

export function* updateMembership(action) {
  try {
    yield put({ type: LOADING.SUBMITTING });
    yield put({ type: LOADING.VALIDATING });
    yield call(patchMembership, action.payload);
    const { data: { entity } } = yield call(fetchMembership, action.payload);
    yield put({ type: MEMBERSHIP.SUCCESS, payload: entity });
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: MESSAGES.MEMBERSHIP.UPDATE_SUCCESS,
    });
    yield put({ type: LOADING.VALIDATED });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
  }
}

export function* deleteMembership(action) {
  try {
    yield put({ type: LOADING.SUBMITTING });
    yield put({ type: LOADING.VALIDATING });
    yield call(deleteMember, action.payload);
    const { data: { entity } } = yield call(fetchMembership, action.payload);
    yield put({ type: MEMBERSHIP.SUCCESS, payload: entity });
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: MESSAGES.MEMBERSHIP.DELETE_SUCCESS,
    });
    yield put({ type: LOADING.VALIDATED });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
  }
}
